/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityPastebinResultMetadata
 */
export interface ControlEntityPastebinResultMetadata {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResultMetadata
     */
    scrape_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResultMetadata
     */
    full_url?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityPastebinResultMetadata
     */
    size?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityPastebinResultMetadata
     */
    tags?: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityPastebinResultMetadata interface.
 */
export function instanceOfControlEntityPastebinResultMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityPastebinResultMetadataFromJSON(json: any): ControlEntityPastebinResultMetadata {
    return ControlEntityPastebinResultMetadataFromJSONTyped(json, false);
}

export function ControlEntityPastebinResultMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityPastebinResultMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scrape_url': !exists(json, 'scrape_url') ? undefined : json['scrape_url'],
        'full_url': !exists(json, 'full_url') ? undefined : json['full_url'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function ControlEntityPastebinResultMetadataToJSON(value?: ControlEntityPastebinResultMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scrape_url': value.scrape_url,
        'full_url': value.full_url,
        'size': value.size,
        'tags': value.tags,
    };
}

